/**
 * PF Revamp — DraftStore public barrel.
 *
 * Consumers import the singleton `draftStore` and call it directly (for the
 * auto-save subscription) or let `purchaseFlowDrafts.query.ts` wrap it in
 * React Query hooks.
 *
 * v2 swap: replace the `new LocalDraftStore()` line with a BE-backed adapter
 * (e.g. `new HttpDraftStore(api)`). All downstream code stays untouched.
 */

import { LocalDraftStore } from './localDraftStore'
import type { DraftStore } from './draftStore'

export type { DraftStore, DraftMeta, DraftScope } from './draftStore'
export { DRAFT_RETENTION_DAYS, deriveDraftMeta, isDraftVisibleTo, isEmptyDraft } from './draftStore'
export { LocalDraftStore, purgeAllDrafts } from './localDraftStore'
export { PF_VERSION } from './pfVersion'

/** Process-wide singleton. Injected into React Query hooks. */
export const draftStore: DraftStore = new LocalDraftStore()
